/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import {PeriodBundlesTableColumnEnum} from '../models/period-bundles-table-column.enum';
import * as PeriodBundlesTableDataPipes from '../data-pipes/period-bundles-table-data-pipes';
import * as FinancialNumberDataPipe from '../../util/financial-number/pipe/financial-number-data-pipe';
import {UndefinedValuePipe} from '../../../shared/pipes/undefined-value/undefined-value.pipe';
import {PartNumberChangesColumnEnum} from '../../../part-number-changes/models/part-number-changes-column.enum';
import * as TablePartNumberChangesPipes
    from '../../../part-number-changes/part-number-changes-main-page/data-pipes/part-number-changes-main-page-data-pipes';

const periodBundlesHeadersConfiguration: {
    number: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    status: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    totalAmount: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    linesQuantity: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    totalCostProgress: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    closedBy: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    closedOn: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    additionalCriterion: TableHeaderEntryModel<string>;
    additionalValue: TableHeaderEntryModel<string>;
    sent: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
    totalSettlements: TableHeaderEntryModel<PeriodBundlesTableColumnEnum>;
} = {
    number: {
        code: PeriodBundlesTableColumnEnum.NUMBER,
        name: 'Bundle No.',
        sortable: false,
        widthWeight: 10,
        hasCopyPaste: true
    },
    status: {
        code: PeriodBundlesTableColumnEnum.STATUS,
        name: 'Status',
        sortable: false,
        widthWeight: 7,
        hasDot: true,
        dataPipe: PeriodBundlesTableDataPipes.statusPipe,
        hasCopyPaste: true
    },
    closedBy: {
        code: PeriodBundlesTableColumnEnum.CLOSED_BY,
        name: 'Closed by',
        sortable: false,
        widthWeight: 10,
        dataPipe: PeriodBundlesTableDataPipes.userPipe,
        hasCopyPaste: true
    },
    closedOn: {
        code: PeriodBundlesTableColumnEnum.CLOSED_ON,
        name: 'Closed on',
        sortable: false,
        widthWeight: 12,
        dataPipe: PeriodBundlesTableDataPipes.closedOnPipe,
        hasCopyPaste: true
    },
    totalAmount: {
        code: PeriodBundlesTableColumnEnum.TOTAL_GROSS_COST,
        name: 'Total amount',
        sortable: false,
        widthWeight: 12,
        hasTextAlignRight: true,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasCopyPaste: true
    },
    linesQuantity: {
        code: PeriodBundlesTableColumnEnum.LINES_QUANTITY,
        name: 'Lines quantity',
        sortable: false,
        widthWeight: 14
    },
    totalCostProgress: {
        code: PeriodBundlesTableColumnEnum.TOTAL_COST_PROGRESS,
        name: 'Total amount progress',
        sortable: false,
        widthWeight: 14,
        hasTextAlignRight: false,
        dataPipe: (new UndefinedValuePipe()).transform
    },
    additionalCriterion: {
        code: null,
        name: null,
        sortable: false,
        widthWeight: 8,
        dataPipe: (new UndefinedValuePipe()).transform,
        hasCopyPaste: true
    },
    additionalValue: {
        code: null,
        name: null,
        sortable: false,
        widthWeight: 10,
        hasTextAlignRight: true,
        dataPipe: FinancialNumberDataPipe.financialNumberPipe,
        hasCopyPaste: true
    },
    sent: {
        code: PeriodBundlesTableColumnEnum.SENT,
        name: 'Sent/Unsent',
        sortable: false,
        widthWeight: 8,
        dataPipe: PeriodBundlesTableDataPipes.sentUnsentPipe
    },
    totalSettlements: {
        code: PeriodBundlesTableColumnEnum.TOTAL_SETTLEMENTS,
        name: 'Total settlements',
        sortable: false,
        widthWeight: 8
    }
};

export default periodBundlesHeadersConfiguration;
